import React from 'react';
import { Icon, ICONS } from 'components/Icons';
import { Link } from 'react-router-dom';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';

import './ActivityBreakdown.scss';

export default function ActivityBreakdown({
  showByDefault,
  showActivityBreakdown,
  setShowActivityBreakdown,
  userLevelGoals,
  closeBottomSheet,
  isEmptyUser,
  userLevel,
}) {
  function renderCheck(condition) {
    if (condition) {
      return (
        <div className="check checked d-inline-flex align-items-center justify-content-center">
          <Icon icon={ICONS.CHECK} className="av-white" size={12} />
        </div>
      );
    } else {
      return <div className="check" />;
    }
  }

  return !isEmptyUser ? (
    <div className="level-card">
      <div className="title-container">
        <div className="title-text">Level {userLevel}</div>
        {!showByDefault ? (
          <div
            className="toggle-button"
            onClick={() => setShowActivityBreakdown(!showActivityBreakdown)}
          >
            {showActivityBreakdown ? 'Hide' : 'Show'} breakdown
          </div>
        ) : (
          <Icon
            icon={ICONS.CLOSE}
            onClick={closeBottomSheet}
            className="toggle-button"
          />
        )}
      </div>
      <div className="topic-progress full mb-4">
        <div
          className="completed"
          style={{ width: `${userLevelGoals.percentageCompleted}%` }}
        />
      </div>
      {(showByDefault || showActivityBreakdown) && (
        <React.Fragment>
          <div className="goals-title my-4">Goals completed this week</div>
          <div className="goals">
            {userLevelGoals.completedGoals.map(userGoal => (
              <div className="d-flex align-items-center justify-content-between my-4">
                <div className="mr-1">{userGoal.goalDisplayAs}</div>
                {renderCheck(userGoal.status)}
              </div>
            ))}
          </div>
          <div
            className={`goals ${
              [0, 100].includes(userLevelGoals.percentageCompleted)
                ? ''
                : 'upper-line'
            }`}
          >
            {userLevelGoals.nonCompletedGoals.map(userGoal => (
              <div className="d-flex align-items-center justify-content-between my-4">
                <div className="mr-1">{userGoal.goalDisplayAs}</div>
                {renderCheck(userGoal.status)}
              </div>
            ))}
          </div>
        </React.Fragment>
      )}
    </div>
  ) : (
    <div className="level-card">
      <div className="title-container">
        <div className="title-text">Level 0</div>
        {showByDefault && (
          <Icon
            icon={ICONS.CLOSE}
            onClick={closeBottomSheet}
            className="toggle-button"
          />
        )}
      </div>
      <div className="topic-progress full mb-4">
        <div className="completed" style={{ width: `5%` }} />
      </div>
      <div className="goals-subtext my-4">
        During sign-up, we will ask you to set your goals for the week.
        Completing those will help you "Level Up" your AverPoint profile.
      </div>
      <Link to="/auth/signUp?referrer=averpoint-logged-out-page">
        <RectangularButton className="signup-button w-100 mt-2 mb-4">
          Sign Up
        </RectangularButton>
      </Link>
    </div>
  );
}
